import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api, money, errMsg } from "../../lib/api";
import { Loading } from "../../components/PageHeader";
import { AdminTitle, Pill, ORDER_TONE, ErrorBox } from "./AdminLayout";

const STATUSES = ["", "paid", "shipped", "pending", "cancelled"];

export default function AdminOrders() {
  const [params, setParams] = useSearchParams();
  const status = params.get("status") || "";
  const [q, setQ] = useState("");
  const [orders, setOrders] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => {
    const t = setTimeout(() => api.get("/admin/orders", { params: { status: status || undefined, q: q || undefined } })
      .then((r) => { setOrders(r.data); setErr(""); }).catch((e) => setErr(errMsg(e))), 250);
    return () => clearTimeout(t);
  }, [status, q]);
  return (
    <div data-testid="admin-orders">
      <AdminTitle eyebrow="Sales" title="Orders" />
      <div className="mb-6 flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
        <div className="flex flex-wrap gap-2">
          {STATUSES.map((s) => (
            <button key={s || "all"} onClick={() => setParams(s ? { status: s } : {})} data-testid={`orders-filter-${s || "all"}`}
              className={`border px-4 py-2 text-[0.68rem] uppercase tracking-[0.2em] transition-colors ${status === s ? "border-[color:var(--wb-gold)] text-wb-gold" : "border-transparent muted hover:text-wb-text"}`}>
              {s || "All"}
            </button>
          ))}
        </div>
        <input className="wb-input md:!w-72" placeholder="Order # or email…" value={q} onChange={(e) => setQ(e.target.value)} data-testid="orders-search-input" />
      </div>
      {err ? <ErrorBox msg={err} /> : !orders ? <Loading /> : orders.length === 0 ? <p className="py-10 muted" data-testid="admin-orders-empty">No orders match.</p> : (
        <div className="overflow-x-auto border wb-line">
          <table className="w-full text-sm">
            <thead><tr className="border-b wb-line text-left">{["Order", "Date", "Buyer", "Items", "Status", "Total"].map((h) => <th key={h} className="px-4 py-3 font-mono text-[0.62rem] uppercase tracking-[0.2em] font-normal muted">{h}</th>)}</tr></thead>
            <tbody>
              {orders.map((o) => (
                <tr key={o.id} className="border-b wb-line hover:bg-wb-card" data-testid={`admin-order-row-${o.order_number}`}>
                  <td className="px-4 py-3"><Link to={`/admin/orders/${o.id}`} className="font-mono text-xs hover:text-wb-gold" data-testid="admin-order-link">{o.order_number}</Link></td>
                  <td className="px-4 py-3 font-mono text-xs muted">{new Date(o.created_at).toLocaleDateString()}</td>
                  <td className="px-4 py-3 muted">{o.email}</td>
                  <td className="px-4 py-3 muted">{o.items.map((i) => i.title).join(", ")}</td>
                  <td className="px-4 py-3"><Pill tone={ORDER_TONE[o.status]}>{o.status}</Pill></td>
                  <td className="px-4 py-3 font-mono">{money(o.amount_paid ?? o.total)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
